import { render } from "./VersionContent.vue?vue&type=template&id=1a644c46&scoped=true&ts=true&lang=pug"
import script from "./VersionContent.vue?vue&type=script&lang=ts"
export * from "./VersionContent.vue?vue&type=script&lang=ts"

import "./VersionContent.vue?vue&type=style&index=0&id=1a644c46&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a644c46"]])

export default __exports__